// Power BI Embedding Configuration

export const POWERBI_CONFIG = {
  // RLS MODE: Set to false to enable Row-Level Security
  // IMPORTANT: RLS-enabled datasets require bypassRLS to be false
  bypassRLS: true, // Set to false for RLS-enabled datasets
  
  // Default user identity (used as fallback if user.email is not available)
  defaultUserIdentity: {
    username: 'test@test.com',
    roles: []
  }
};
